export default "__VITE_PUBLIC_ASSET__16da3c36__"